import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider } from 'styled-components';

const theme = {
  'beige': 'hsl(44, 36%, 86%)',

  'blue-dark': 'hsl(253, 100%, 58%)',
  'blue-normal': 'hsl(253, 100%, 78%)',
  'blue-xlight': 'hsl(253, 100%, 98%)',

  'green-dark': 'hsl(154, 82%, 13%)',
  'green-normal': 'hsl(154, 82%, 33%)',
  'green-xlight': 'hsl(154, 82%, 73%)',

  'grey-dark': 'hsl(0, 0%, 50%)',
  'grey-normal': 'hsl(0, 0%, 80%)',
  'grey-light': 'hsl(0, 0%, 90%)',
  'grey-xlight': 'hsl(0, 0%, 95%)',

  'orange-dark': 'hsl(24, 88%, 35%)',
  'orange-normal': 'hsl(24, 88%, 55%)',

  'pink-normal': 'hsl(344, 73%, 78%)',

  'red-dark': 'hsl(344, 73%, 58%)',
  'red-normal': 'hsl(344, 73%, 78%)',

  'font-family': 'Staff, Arial, "PT Sans", sans-serif',

  'text-black': 'hsl(0, 0%, 0%)',
  'text-white': 'hsl(0, 0%, 100%)',

  'yellow-normal': 'hsl(50, 93%, 59%)',

  'font-size-small': '10pt',
  'font-size-normal': '13pt',
  'font-size-large': '14pt',
  'font-size-xlarge': '18pt',

  'line-height-small': '13pt',
  'line-height-normal': '17pt',
  'line-height-large': '18pt',
  'line-height-xlarge': '22pt',
};

// Aliases
theme['btn-blue'] = theme['blue-normal']
theme['btn-blue-text-shadow'] = theme['blue-dark']
theme['btn-green'] = theme['green-normal']
theme['btn-green-text-shadow'] = theme['green-dark']
theme['btn-grey'] = theme['grey-normal']
theme['btn-grey-text-shadow'] = theme['grey-dark']
theme['btn-orange'] = theme['orange-normal']
theme['btn-orange-text-shadow'] = theme['orange-dark']
theme['btn-red'] = theme['red-normal']
theme['btn-red-text-shadow'] = theme['red-dark']

const ZeckitTheme = ({ children }) =>
  <ThemeProvider theme={theme}>
    {children}
  </ThemeProvider>;

ZeckitTheme.propTypes = { children: PropTypes.node.isRequired };

export default ZeckitTheme;
